/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as AppRouteImport } from './../../pages/_app'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as AppTeamRouteImport } from './../../pages/_app/team'
import { Route as AppTasksRouteImport } from './../../pages/_app/tasks'
import { Route as AppProjectsRouteImport } from './../../pages/_app/projects'
import { Route as AppMyTasksRouteImport } from './../../pages/_app/my-tasks'
import { Route as AppMyCompanyRouteImport } from './../../pages/_app/my-company'
import { Route as AppBoardsRouteImport } from './../../pages/_app/boards'
import { Route as AppEmployeesIndexRouteImport } from './../../pages/_app/employees/index'
import { Route as AppCompaniesIndexRouteImport } from './../../pages/_app/companies/index'
import { Route as AppEmployeesEmployeeIdRouteImport } from './../../pages/_app/employees/$employeeId'
import { Route as AppCompaniesCompanyRouteImport } from './../../pages/_app/companies/$company'
import { Route as AppCompanyProjectRouteImport } from './../../pages/_app/$company/$project'
import { Route as AppCompaniesCompanyMeetingsMeetingRouteImport } from './../../pages/_app/companies/$company_.meetings.$meeting'
import { Route as AppCompaniesCompanyInvoicesInvoiceRouteImport } from './../../pages/_app/companies/$company_.invoices.$invoice'
import { Route as AppCompaniesCompanyDocumentsDocRouteImport } from './../../pages/_app/companies/$company_.documents.$doc'
import { Route as AppCompanyProjectTasksTaskRouteImport } from './../../pages/_app/$company/$project_.tasks.$task'
import { Route as AppCompanyProjectMeetingsMeetingRouteImport } from './../../pages/_app/$company/$project_.meetings.$meeting'
import { Route as AppCompanyProjectInvoicesInvoiceRouteImport } from './../../pages/_app/$company/$project_.invoices.$invoice'
import { Route as AppCompanyProjectDocumentsDocRouteImport } from './../../pages/_app/$company/$project_.documents.$doc'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppMyTasksRoute = AppMyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppMyCompanyRoute = AppMyCompanyRouteImport.update({
  id: '/my-company',
  path: '/my-company',
  getParentRoute: () => AppRoute,
} as any)
const AppBoardsRoute = AppBoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesIndexRoute = AppEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesIndexRoute = AppCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesEmployeeIdRoute = AppEmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesCompanyRoute = AppCompaniesCompanyRouteImport.update({
  id: '/companies/$company',
  path: '/companies/$company',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyProjectRoute = AppCompanyProjectRouteImport.update({
  id: '/$company/$project',
  path: '/$company/$project',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesCompanyMeetingsMeetingRoute =
  AppCompaniesCompanyMeetingsMeetingRouteImport.update({
    id: '/companies/$company_/meetings/$meeting',
    path: '/companies/$company/meetings/$meeting',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompaniesCompanyInvoicesInvoiceRoute =
  AppCompaniesCompanyInvoicesInvoiceRouteImport.update({
    id: '/companies/$company_/invoices/$invoice',
    path: '/companies/$company/invoices/$invoice',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompaniesCompanyDocumentsDocRoute =
  AppCompaniesCompanyDocumentsDocRouteImport.update({
    id: '/companies/$company_/documents/$doc',
    path: '/companies/$company/documents/$doc',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyProjectTasksTaskRoute =
  AppCompanyProjectTasksTaskRouteImport.update({
    id: '/$company/$project_/tasks/$task',
    path: '/$company/$project/tasks/$task',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyProjectMeetingsMeetingRoute =
  AppCompanyProjectMeetingsMeetingRouteImport.update({
    id: '/$company/$project_/meetings/$meeting',
    path: '/$company/$project/meetings/$meeting',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyProjectInvoicesInvoiceRoute =
  AppCompanyProjectInvoicesInvoiceRouteImport.update({
    id: '/$company/$project_/invoices/$invoice',
    path: '/$company/$project/invoices/$invoice',
    getParentRoute: () => AppRoute,
  } as any)
const AppCompanyProjectDocumentsDocRoute =
  AppCompanyProjectDocumentsDocRouteImport.update({
    id: '/$company/$project_/documents/$doc',
    path: '/$company/$project/documents/$doc',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/boards': typeof AppBoardsRoute
  '/my-company': typeof AppMyCompanyRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/projects': typeof AppProjectsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/$company/$project': typeof AppCompanyProjectRoute
  '/companies/$company': typeof AppCompaniesCompanyRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/companies/': typeof AppCompaniesIndexRoute
  '/employees/': typeof AppEmployeesIndexRoute
  '/$company/$project/documents/$doc': typeof AppCompanyProjectDocumentsDocRoute
  '/$company/$project/invoices/$invoice': typeof AppCompanyProjectInvoicesInvoiceRoute
  '/$company/$project/meetings/$meeting': typeof AppCompanyProjectMeetingsMeetingRoute
  '/$company/$project/tasks/$task': typeof AppCompanyProjectTasksTaskRoute
  '/companies/$company/documents/$doc': typeof AppCompaniesCompanyDocumentsDocRoute
  '/companies/$company/invoices/$invoice': typeof AppCompaniesCompanyInvoicesInvoiceRoute
  '/companies/$company/meetings/$meeting': typeof AppCompaniesCompanyMeetingsMeetingRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/boards': typeof AppBoardsRoute
  '/my-company': typeof AppMyCompanyRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/projects': typeof AppProjectsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/$company/$project': typeof AppCompanyProjectRoute
  '/companies/$company': typeof AppCompaniesCompanyRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/companies': typeof AppCompaniesIndexRoute
  '/employees': typeof AppEmployeesIndexRoute
  '/$company/$project/documents/$doc': typeof AppCompanyProjectDocumentsDocRoute
  '/$company/$project/invoices/$invoice': typeof AppCompanyProjectInvoicesInvoiceRoute
  '/$company/$project/meetings/$meeting': typeof AppCompanyProjectMeetingsMeetingRoute
  '/$company/$project/tasks/$task': typeof AppCompanyProjectTasksTaskRoute
  '/companies/$company/documents/$doc': typeof AppCompaniesCompanyDocumentsDocRoute
  '/companies/$company/invoices/$invoice': typeof AppCompaniesCompanyInvoicesInvoiceRoute
  '/companies/$company/meetings/$meeting': typeof AppCompaniesCompanyMeetingsMeetingRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/boards': typeof AppBoardsRoute
  '/_app/my-company': typeof AppMyCompanyRoute
  '/_app/my-tasks': typeof AppMyTasksRoute
  '/_app/projects': typeof AppProjectsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/team': typeof AppTeamRoute
  '/_app/$company/$project': typeof AppCompanyProjectRoute
  '/_app/companies/$company': typeof AppCompaniesCompanyRoute
  '/_app/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/_app/companies/': typeof AppCompaniesIndexRoute
  '/_app/employees/': typeof AppEmployeesIndexRoute
  '/_app/$company/$project_/documents/$doc': typeof AppCompanyProjectDocumentsDocRoute
  '/_app/$company/$project_/invoices/$invoice': typeof AppCompanyProjectInvoicesInvoiceRoute
  '/_app/$company/$project_/meetings/$meeting': typeof AppCompanyProjectMeetingsMeetingRoute
  '/_app/$company/$project_/tasks/$task': typeof AppCompanyProjectTasksTaskRoute
  '/_app/companies/$company_/documents/$doc': typeof AppCompaniesCompanyDocumentsDocRoute
  '/_app/companies/$company_/invoices/$invoice': typeof AppCompaniesCompanyInvoicesInvoiceRoute
  '/_app/companies/$company_/meetings/$meeting': typeof AppCompaniesCompanyMeetingsMeetingRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/boards'
    | '/my-company'
    | '/my-tasks'
    | '/projects'
    | '/tasks'
    | '/team'
    | '/$company/$project'
    | '/companies/$company'
    | '/employees/$employeeId'
    | '/companies/'
    | '/employees/'
    | '/$company/$project/documents/$doc'
    | '/$company/$project/invoices/$invoice'
    | '/$company/$project/meetings/$meeting'
    | '/$company/$project/tasks/$task'
    | '/companies/$company/documents/$doc'
    | '/companies/$company/invoices/$invoice'
    | '/companies/$company/meetings/$meeting'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/boards'
    | '/my-company'
    | '/my-tasks'
    | '/projects'
    | '/tasks'
    | '/team'
    | '/$company/$project'
    | '/companies/$company'
    | '/employees/$employeeId'
    | '/companies'
    | '/employees'
    | '/$company/$project/documents/$doc'
    | '/$company/$project/invoices/$invoice'
    | '/$company/$project/meetings/$meeting'
    | '/$company/$project/tasks/$task'
    | '/companies/$company/documents/$doc'
    | '/companies/$company/invoices/$invoice'
    | '/companies/$company/meetings/$meeting'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/boards'
    | '/_app/my-company'
    | '/_app/my-tasks'
    | '/_app/projects'
    | '/_app/tasks'
    | '/_app/team'
    | '/_app/$company/$project'
    | '/_app/companies/$company'
    | '/_app/employees/$employeeId'
    | '/_app/companies/'
    | '/_app/employees/'
    | '/_app/$company/$project_/documents/$doc'
    | '/_app/$company/$project_/invoices/$invoice'
    | '/_app/$company/$project_/meetings/$meeting'
    | '/_app/$company/$project_/tasks/$task'
    | '/_app/companies/$company_/documents/$doc'
    | '/_app/companies/$company_/invoices/$invoice'
    | '/_app/companies/$company_/meetings/$meeting'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-tasks': {
      id: '/_app/my-tasks'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof AppMyTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-company': {
      id: '/_app/my-company'
      path: '/my-company'
      fullPath: '/my-company'
      preLoaderRoute: typeof AppMyCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/boards': {
      id: '/_app/boards'
      path: '/boards'
      fullPath: '/boards'
      preLoaderRoute: typeof AppBoardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/': {
      id: '/_app/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AppEmployeesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/': {
      id: '/_app/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AppCompaniesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/$employeeId': {
      id: '/_app/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof AppEmployeesEmployeeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$company': {
      id: '/_app/companies/$company'
      path: '/companies/$company'
      fullPath: '/companies/$company'
      preLoaderRoute: typeof AppCompaniesCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$company/$project': {
      id: '/_app/$company/$project'
      path: '/$company/$project'
      fullPath: '/$company/$project'
      preLoaderRoute: typeof AppCompanyProjectRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$company_/meetings/$meeting': {
      id: '/_app/companies/$company_/meetings/$meeting'
      path: '/companies/$company/meetings/$meeting'
      fullPath: '/companies/$company/meetings/$meeting'
      preLoaderRoute: typeof AppCompaniesCompanyMeetingsMeetingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$company_/invoices/$invoice': {
      id: '/_app/companies/$company_/invoices/$invoice'
      path: '/companies/$company/invoices/$invoice'
      fullPath: '/companies/$company/invoices/$invoice'
      preLoaderRoute: typeof AppCompaniesCompanyInvoicesInvoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$company_/documents/$doc': {
      id: '/_app/companies/$company_/documents/$doc'
      path: '/companies/$company/documents/$doc'
      fullPath: '/companies/$company/documents/$doc'
      preLoaderRoute: typeof AppCompaniesCompanyDocumentsDocRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$company/$project_/tasks/$task': {
      id: '/_app/$company/$project_/tasks/$task'
      path: '/$company/$project/tasks/$task'
      fullPath: '/$company/$project/tasks/$task'
      preLoaderRoute: typeof AppCompanyProjectTasksTaskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$company/$project_/meetings/$meeting': {
      id: '/_app/$company/$project_/meetings/$meeting'
      path: '/$company/$project/meetings/$meeting'
      fullPath: '/$company/$project/meetings/$meeting'
      preLoaderRoute: typeof AppCompanyProjectMeetingsMeetingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$company/$project_/invoices/$invoice': {
      id: '/_app/$company/$project_/invoices/$invoice'
      path: '/$company/$project/invoices/$invoice'
      fullPath: '/$company/$project/invoices/$invoice'
      preLoaderRoute: typeof AppCompanyProjectInvoicesInvoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$company/$project_/documents/$doc': {
      id: '/_app/$company/$project_/documents/$doc'
      path: '/$company/$project/documents/$doc'
      fullPath: '/$company/$project/documents/$doc'
      preLoaderRoute: typeof AppCompanyProjectDocumentsDocRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppBoardsRoute: typeof AppBoardsRoute
  AppMyCompanyRoute: typeof AppMyCompanyRoute
  AppMyTasksRoute: typeof AppMyTasksRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppTeamRoute: typeof AppTeamRoute
  AppCompanyProjectRoute: typeof AppCompanyProjectRoute
  AppCompaniesCompanyRoute: typeof AppCompaniesCompanyRoute
  AppEmployeesEmployeeIdRoute: typeof AppEmployeesEmployeeIdRoute
  AppCompaniesIndexRoute: typeof AppCompaniesIndexRoute
  AppEmployeesIndexRoute: typeof AppEmployeesIndexRoute
  AppCompanyProjectDocumentsDocRoute: typeof AppCompanyProjectDocumentsDocRoute
  AppCompanyProjectInvoicesInvoiceRoute: typeof AppCompanyProjectInvoicesInvoiceRoute
  AppCompanyProjectMeetingsMeetingRoute: typeof AppCompanyProjectMeetingsMeetingRoute
  AppCompanyProjectTasksTaskRoute: typeof AppCompanyProjectTasksTaskRoute
  AppCompaniesCompanyDocumentsDocRoute: typeof AppCompaniesCompanyDocumentsDocRoute
  AppCompaniesCompanyInvoicesInvoiceRoute: typeof AppCompaniesCompanyInvoicesInvoiceRoute
  AppCompaniesCompanyMeetingsMeetingRoute: typeof AppCompaniesCompanyMeetingsMeetingRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBoardsRoute: AppBoardsRoute,
  AppMyCompanyRoute: AppMyCompanyRoute,
  AppMyTasksRoute: AppMyTasksRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppTasksRoute: AppTasksRoute,
  AppTeamRoute: AppTeamRoute,
  AppCompanyProjectRoute: AppCompanyProjectRoute,
  AppCompaniesCompanyRoute: AppCompaniesCompanyRoute,
  AppEmployeesEmployeeIdRoute: AppEmployeesEmployeeIdRoute,
  AppCompaniesIndexRoute: AppCompaniesIndexRoute,
  AppEmployeesIndexRoute: AppEmployeesIndexRoute,
  AppCompanyProjectDocumentsDocRoute: AppCompanyProjectDocumentsDocRoute,
  AppCompanyProjectInvoicesInvoiceRoute: AppCompanyProjectInvoicesInvoiceRoute,
  AppCompanyProjectMeetingsMeetingRoute: AppCompanyProjectMeetingsMeetingRoute,
  AppCompanyProjectTasksTaskRoute: AppCompanyProjectTasksTaskRoute,
  AppCompaniesCompanyDocumentsDocRoute: AppCompaniesCompanyDocumentsDocRoute,
  AppCompaniesCompanyInvoicesInvoiceRoute:
    AppCompaniesCompanyInvoicesInvoiceRoute,
  AppCompaniesCompanyMeetingsMeetingRoute:
    AppCompaniesCompanyMeetingsMeetingRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
